export const BASE_URL = process.env.LOCAL_FACADE_SERVER_FULL_ADDRESS
export const COPY_TRADING_URL = process.env.COPY_TRADING_URL
//=============================================local store===============================================
export const EP_LOGIN = '/api/login'
export const EP_USER_LOGIN_2FA = '/api/login/twofactor'
export const EP_LOGOUT = '/signout'
export const EP_FRESH_DATA = '/get/fresh/user/data'
export const EP_FORGOT_PASSWORD = '/forgot/password'
export const EP_RESET_PASSWORD_FROM_HASH = '/change/via/forgot/password'
export const EP_CHANGE_PASSWORD = '/api/act/change/password'
//============================================common-plugin==============================================
export const EP_GET_PROFILE_INFO = '/get/user/profile'
//=============================================registerStep plugin=======================================
export const EP_STEP1 = '/api/create/lead'
export const EP_STEP2 = '/api/verify/otp/lead'
export const EP_STEP3 = '/api/user/register'
export const EP_GET_STEP_INFO = '/get/registration/data'
export const EP_DEL_DOC = '/delete/register/docs'

export const EP_STEP4 = '/add/individual/personal/information'
export const EP_STEP5 = '/terms/agreed'
export const EP_STEP6 = '/add/individual/docs'
export const EP_GENERATE_OTP = '/individual/ipv/otp'

export const EP_COR_STEP4 = '/add/corporate/org/information'
export const EP_COR_STEP5 = '/add/corporate/personal/information'
export const EP_COR_STEP7 = '/add/corporate/docs'
//=============================================support plugin=============================================
export const EP_TICKET_REQUEST_OTP = '/ticket/request/otp'
export const EP_TICKET_CHECK_OTP = '/ticket/request'
export const EP_GET_TICKET_LIST = '/list/ticket'
export const EP_GET_TICKET_DETAIL = '/ticket/details'
export const EP_TICKET_REPLY = '/create/ticket/thread'
export const EP_GET_TICKET_REASON_LIST = '/get/ticket/reasons'
export const EP_TICKET_RESEND_OTP = '/ticket/request/otp/resend'
//========================================deposit-withdrawal pluigin====================================================
export const EP_GENERATE_WALLET_ADDRESS                 =               ''


export const EP_GET_USER_CAN_DEPOSIT                    =               '/get/deposit/methods'
export const EP_TRANS_LIMIT_CURRENCY                    =               '/get/deposit/limit'
export const EP_DEMO_DEPOSIT                            =               '/deposit/demo/account'
export const EP_CREDIT_CARD_DEPOSIT                     =               '/get/deposit/url'


export const EP_WITHDRAWAL_REQUEST_OTP                  =               '/withdrawal/request/otp'
export const EP_WITHDRAWAL_CHECK_OTP                    =               '/withdrawal/request'
export const EP_RESEND_EMAIL_LINK                       =               '/withdrawal/request/resend/otp'
export const EP_GET_WITHDRAWAL_DESC                     =               '/get/withdrawal/desc'

export const EP_GET_WITHDRAWAL_METHODS                  =               '/get/withdrawal/methods'
// ========================order list======================
export const EP_OPEN_TRADE_LIST = '/get/open/orders'
export const EP_CANCEL_ORDER_LIST = '/get/cancel/orders'
export const EP_COMPLETED_ORDER_LIST = '/get/filled/orders'
export const EP_ORDER_LIST = '/get/orders'
// =====================trading account======================
export const EP_TRADING_ACCOUNT = '/get/trading/account/list'
// =======================Crypto list========================
export const EP_CRYPTO_LIST = '/get/crypto/list'
    // =======================Crypto list========================
export const EP_GET_MARGIN_INFO = '/get/margin/info'
// =======================payment Method=====================
export const EP_GET_PAYMENT_METHODS = '/get/payment/methods'
// =======================IP ADDRESS=========================
export const EP_IP_ADDRESS_LIST = '/ip/address/list'
export const EP_ADD_IP_ADDRES = '/add/ip/address'
export const EP_UPDATE_IP_ADDRES = '/ip/address/update'
// ================== transaction History ===============
export const EP_DEPOSIT_HISTORY = ''
export const EP_WITHDRAWAL_HISTORY = ''
// ================== Login Info =========================
export const EP_LOGIN_INFO = ''
// ============== favorite Currency List ================
export const EP_GET_FAVORITE_CURRENCY_LIST = '/get/favorite/currency'
export const EP_ADD_FAVORITE_CURRENCY_LIST = '/add/favorite/currency'


// ====================== news data =======================
export const EP_GET_NEWS_DATA = '/api/news/list'
// ============== ECONOMIC CALENDER =======================
export const EP_GET_ECONOMIC_CALENDER_DATA = '/api/get/eco/calender'
// =============== order api =======================
export const EP_GET_OPEN_TRADE = '/api/act/open/trades'
export const EP_CLOSE_TRADE = '/api/act/close/trade'
export const EP_GET_PENDING_ORDER = '/api/act/pending/orders'
export const EP_CANCLE_ORDER = '/api/act/cancel/order'
export const EP_MODIFY_ORDER = '/api/act/modify/order'
export const EP_GET_TRADE_HISTORY = '/api/act/trade/history'
export const EP_GET_REMOVED_TRADE_LIST = '/api/act/remove/order'
export const EP_GET_TRANSACTION_HISTORY = '/api/act/transaction/history'
// ================= ACCOUNT BALANCE =======================
export const EP_GET_ACCOUNT_BALANCE = '/api/act/user/account/balance'
// ================= CURRENCY PAIRS =======================
export const EP_GET_CURRENCY_PAIRS = '/api/get/isins/list'
export const EP_GET_PRICE_SHIFT = '/api/get/shft'
// ================= WATCH LIST =======================
export const EP_GET_WATCH_LIST = '/api/user/watchlist/get'
export const EP_CREATE_WATCH_LIST = '/api/user/watchlist/create'
export const EP_UPDATE_WATCH_LIST = '/api/user/watchlist/update'
export const EP_DELETE_WATCH_LIST = '/api/user/watchlist/delete'

export const EP_GENERATE_2FA_QRCODE = '/api/user/google_authenticator'
export const EP_VERIFY_2FA_QRCODE = '/api/user/google_auth_verify'
export const EP_DISABLE_2FA_QRCODE = '/api/user/google_auth_disabled'

export const EP_GET_ACCOUNT_REPORTS = '/api/act/reports'
export const EP_GET_PROVIDER_LIST 	= '/api/act/service/provider/list'

export const EP_GET_USER_ACCOUNTS 	= '/api/act/user/accounts'
export const EP_CREATE_DEMO_ACC 	= '/api/act/create/demo/account'

export const EP_SET_USER_SETTINGS	= '/api/set/user/account/settings'
export const EP_GET_USER_SETTINGS	= '/api/get/user/account/settings'

export const EP_GET_ACTIVE_PRICE_ALERT	= '/api/act/active/pricealert'
export const EP_GET_TRIGGERED_PRICE_ALERT	= '/api/act/triggered/pricealert'

export const EP_GET_PORTFOLIO    = '/api/act/user/portfolio'

export const EP_SET_RAW_OBJECT    = '/api/set/user/setting'
export const EP_GET_RAW_OBJECT    = '/api/get/user/setting'

export const EP_GET_TECHNICAL_ANALYSIS    = '/api/act/market/sentiment'
export const EP_GET_PIVOT_DATA   = '/api/act/pivot/levels'


export const EP_GET_LEADERS_LIST   = `${COPY_TRADING_URL}/get/leaders`
export const EP_GET_ALL_LEADERS_LIST   = `${COPY_TRADING_URL}/get/all/leaders`
export const EP_GET_LEADER_DETAIL   = `${COPY_TRADING_URL}/get/leaders/detail`
export const EP_GET_LEADER_CHART_DATA    = `${COPY_TRADING_URL}/get/leader/stat`
export const EP_GET_LEADER_TRADE_HISTORY = `${COPY_TRADING_URL}/get/leader/tradeHistory`
export const EP_GET_LEADERS_STAT   = `${COPY_TRADING_URL}/get/leader/stat`
export const EP_GET_FOLLOWERS_SETTING   = `${COPY_TRADING_URL}/followers/setting`
export const EP_FOLLOW_TRADE  = `${COPY_TRADING_URL}/followers/v2/api/user/follow/provider` // POST Api
export const EP_FOLLOW_TRADE_UPDATE  = `${COPY_TRADING_URL}/followers/v2/api/user/follow/provider/update` // PUT Api
export const EP_UNFOLLOW_TRADE  = `${COPY_TRADING_URL}/followers/v2/api/user/unfollow/provider/` // DELETE Api
export const EP_GET_USER_EQUITY_CHART_WITH_LEADER = `${COPY_TRADING_URL}/get/leader/tradeHistory/chart/`
export const EP_GET_USER_COPYTRADING_TOKEN = `/api/copytrading/authentication`



// WEBPACK FOOTER //
// ./src/store/api/endpoints.js